export const FETCH_WFH_PROFILE_FAILURE = 'FETCH_WFH_PROFILE_FAILURE';
export const FETCH_WFH_PROFILE_LOADING = 'FETCH_WFH_PROFILE_LOADING';
export const FETCH_WFH_PROFILE_SUCCESS = 'FETCH_WFH_PROFILE_SUCCESS';

export const ADD_WFH_PROFILE_SUCCESS = 'ADD_WFH_PROFILE_SUCCESS';
export const ADD_WFH_PROFILE_FAILURE = 'ADD_WFH_PROFILE_FAILURE';
export const ADD_WFH_PROFILE_LOADING = 'ADD_WFH_PROFILE_LOADING';

export const UPDATE_WFH_PROFILE_SUCCESS = 'UPDATE_WFH_PROFILE_SUCCESS';
export const UPDATE_WFH_PROFILE_FAILURE = 'UPDATE_WFH_PROFILE_FAILURE';
export const UPDATE_WFH_PROFILE_LOADING = 'UPDATE_WFH_PROFILE_LOADING';

export const DELETE_WFH_PROFILE_SUCCESS = 'DELETE_WFH_PROFILE_SUCCESS';
export const DELETE_WFH_PROFILE_FAILURE = 'DELETE_WFH_PROFILE_FAILURE';
export const DELETE_WFH_PROFILE_LOADING = 'DELETE_WFH_PROFILE_LOADING';

export const FETCH_PLANNING_FAILURE = 'FETCH_PLANNING_FAILURE';
export const FETCH_PLANNING_LOADING = 'FETCH_PLANNING_LOADING';
export const FETCH_PLANNING_SUCCESS = 'FETCH_PLANNING_SUCCESS';
export const UPDATE_PLANNING_FAILURE = 'UPDATE_PLANNING_FAILURE';
export const UPDATE_PLANNING_SUCCESS = 'UPDATE_PLANNING_SUCCESS';
